import { useEffect, useState } from "react";
import { api } from "../lib/api";
import { DEPARTMENTS, inputCls, labelCls } from "../lib/constants";
import PuantajDeptCard from "../components/PuantajDeptCard";

export default function GeneralPuantaj() {
  const [hotels, setHotels] = useState([]);
  const [hotel, setHotel] = useState(null);
  const [date, setDate] = useState(() => new Date().toLocaleDateString("en-CA", { timeZone: "Europe/Istanbul" }));
  const [records, setRecords] = useState([]);

  useEffect(() => {
    api.get("/hotels").then((r) => { setHotels(r.data); setHotel(r.data[0]?.code); });
  }, []);

  const load = () => {
    if (!hotel) return;
    api.get("/puantaj/by-date", { params: { date_str: date, hotel_code: hotel } }).then((r) => setRecords(r.data));
  };
  useEffect(load, [hotel, date]);

  return (
    <div className="max-w-6xl mx-auto">
      <div className="flex items-end justify-between flex-wrap gap-3 mb-5">
        <h1 className="font-display text-xl font-bold text-cyan-300 tracking-widest uppercase text-glow-sm">Genel Puantaj</h1>
        <div>
          <label className={labelCls}>Tarih</label>
          <input data-testid="gp-date" type="date" value={date} onChange={(e) => setDate(e.target.value)} className={inputCls} />
        </div>
      </div>

      <div className="flex gap-2 flex-wrap mb-5 border-b border-cyan-500/20 pb-2">
        {hotels.map((h) => (
          <button key={h.code} data-testid={`gp-hotel-${h.code}`} onClick={() => setHotel(h.code)}
            className={`px-4 py-2 rounded-t-lg font-mono text-xs uppercase tracking-wider transition ${hotel === h.code ? "bg-cyan-500/15 text-cyan-300 border border-cyan-500/40 border-b-transparent" : "text-slate-400 hover:text-cyan-300"}`}>
            {h.name}
          </button>
        ))}
      </div>

      <div className="grid grid-cols-1 lg:grid-cols-2 gap-4 items-start">
        {DEPARTMENTS.map((d) => (
          <PuantajDeptCard key={d.code} dept={d.code} date={date} hotel={hotel} record={records.find((r) => r.department_code === d.code)} onChanged={load} />
        ))}
      </div>
    </div>
  );
}
